import { sliceKeys } from './constants';
import { actionCreators as companies } from './companies';
import { actionCreators as cities } from './cities';
import { actionCreators as houses } from './houses';
import { actionCreators as rooms } from './rooms';
import { actionCreators as relatedRooms } from './relatedRooms';
import { actionCreators as desks } from './desks';
import { actionCreators as create } from './acceptanceCreate';
import { actionCreators as newConfigCreate } from './newConfigCreate';
import { actionCreators as changeDesksSettings } from './changeDesksSettings';
import { actionCreators as attachmentsFilter } from './attachmentsFilter';

export const actionCreators = {
  [sliceKeys.companies]: companies,
  [sliceKeys.cities]: cities,
  [sliceKeys.houses]: houses,
  [sliceKeys.rooms]: rooms,
  [sliceKeys.relatedRooms]: relatedRooms,
  [sliceKeys.desks]: desks,
  [sliceKeys.createPage]: create,
  [sliceKeys.newConfigPage]: newConfigCreate,
  [sliceKeys.changeDesksSettingsPage]: changeDesksSettings,
  [sliceKeys.attachmentsFilter]: attachmentsFilter,
};
